class PermissaoRecurso {
    /**
     *
     * @type {number}
     */
    id;
    /**
     *
     * @type {string}
     */
    nome;
    /**
     *
     * @type {string}
     */
    descricao;
    /**
     *
     * @type {string}
     */
    chave;
    /**
     *
     * @type {boolean}
     */
    visualizar;
    /**
     *
     * @type {boolean}
     */
    inserir;
    /**
     *
     * @type {boolean}
     */
    alterar;
    /**
     *
     * @type {boolean}
     */
    excluir;

    /**
     *
     * @param {number} id
     * @param {string} nome
     * @param {string} descricao
     * @param {string} chave
     * @param {boolean} visualizar
     * @param {boolean} inserir
     * @param {boolean} alterar
     * @param {boolean} excluir
     */
    constructor(id, nome, descricao, chave, visualizar, inserir, alterar, excluir) {
        this.id = id;
        this.nome = nome;
        this.descricao = descricao;
        this.chave = chave;
        this.visualizar = visualizar;
        this.inserir = inserir;
        this.alterar = alterar;
        this.excluir = excluir;
    }

    /**
     *
     * @returns {string}
     */
    get visualizarText() {
        return this.visualizar ? 'Sim' : 'Não';
    }

    /**
     *
     * @returns {string}
     */
    get inserirText() {
        return this.inserir ? 'Sim' : 'Não';
    }

    /**
     *
     * @returns {string}
     */
    get alterarText() {
        return this.alterar ? 'Sim' : 'Não';
    }

    /**
     *
     * @returns {string}
     */
    get excluirText() {
        return this.excluir ? 'Sim' : 'Não';
    }
}

export default PermissaoRecurso;